import UserData from './UserData/userData'
import AllScreen from './AllScreen/AllScreen'
import MenuData from './MenuData/MenuData'
export default {
    UserData,
    AllScreen,
    MenuData
}